'use client'

import { PropsWithChildren } from 'react'
import { CssBaseline } from '@mui/material'
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter'
import { ThemeProvider } from '@mui/material/styles'

import AppInsightsProvider from '@/providers/AppInsightsProvider'
import I18nAppProvider from '@/providers/I18nProvider'
import LocaleContext from '@/providers/context/LocaleContext'
import customTheme from '@/theme/customTheme'
import { defaultLocale } from '@/utils/locale'

interface AllProvidersProps extends PropsWithChildren {
  locale: string
}

const AllProviders = ({ children, locale }: AllProvidersProps) => {
  return (
    <AppInsightsProvider>
      <I18nAppProvider locale={locale}>
        <LocaleContext.Provider
          value={{
            locale,
            language: locale.split('-')[0],
            localePrefix: `/${locale}`,
            isImplicit: locale === defaultLocale
          }}>
          <AppRouterCacheProvider options={{ enableCssLayer: true }}>
            <InitColorSchemeScript attribute='class' />
            <ThemeProvider theme={customTheme}>
              <CssBaseline />
              {children}
            </ThemeProvider>
          </AppRouterCacheProvider>
        </LocaleContext.Provider>
      </I18nAppProvider>
    </AppInsightsProvider>
  )
}

export default AllProviders
